export default __webpack_public_path__ + "static/restroom_w.607b84b8adf239822cb649a8aa0a3fb6.png";